import React from 'react';
import cl from '../../formComponents/FormControlCaption.module.css';
import cl2 from './WeightCoefficientsFormControlCaption.module.css';
import InlineTip from "../../components/InlineTip";
import {inlineTipMargin} from "../../AppVars";

const WeightCoefficientsFormControlCaption = ({text, text2, subText, tipText}) => {
    return (
        <div className={cl.main}>
            {text}
            {text2 && <span className={cl2.text2}> {text2}</span>}
            {subText && <p className={cl2.subText}>{subText}</p>}
            {tipText && <InlineTip text={tipText} style={{marginLeft:`${inlineTipMargin}px`}}/>}
        </div>
    );
};

export default WeightCoefficientsFormControlCaption;